<div class="height-container">
    <div *ngIf="!showAdmin">
        <nav class="tab-nav">
            <a class="tab-title" *ngFor="let category of categories"
               [ngClass]="{ 'is-active': selectedCategory === category.id }"
               (click)="setSelectedCategory(category.id)">{{ category.categoryShortName }}</a>
        </nav>
        <section class="tab-contents">
            <article class="tab-section is-active">
                <div class="panel" [ngClass]="{ 'panel-red': message.isOutage }" *ngFor="let message of filteredUserMessages">
                    <h5 class="panel-title" (click)="toggleOpen(message)">
                        <span [ngClass]="{ 'icon-ui-checkbox-checked': message.isRead, 'icon-ui-checkbox-unchecked': !message.isRead }"></span>
                        <b>{{ message.systemMessage.systemMessageCategory.categoryName }}:</b> {{ message.systemMessage.title }}
                    </h5>
                    <div class="panel-body" [hidden]="!message.show">
                        <div class="form-group" [innerHtml]="message.systemMessage.message"></div>
                        <div class="form-group" *ngIf="!message.isDismissed">
                            <button class="btn btn-small btn-clear right" (click)="dismissMessage(message); message.show = false;">
                                <span class="icon-ui-close"></span> Dismiss
                            </button>
                        </div>
                    </div>
                </div>
                <div *ngIf="!filteredUserMessages || !filteredUserMessages.length">
                    No messages found.
                </div>
            </article>
        </section>
    </div>
    <ng-container *ngIf="showAdmin">
        <ng-container *ngIf="!addEdit">
            <mc-table-ng (buttonClickEvent)="onMessageTableButtonClick($event)"
                         [columnSettings]="messageTableSettings"
                         columnSortMode="single"
                         [data]="filteredSystemMessages"
                         showColumnHeaders="true"
                         tableHeight="400px">
            </mc-table-ng>
        </ng-container>
        <div class="form" *ngIf="addEdit">
            <div class="setting">
                <label for="category">Category</label>
                <select id="category" name="category" [(ngModel)]="currentMessage.systemMessageCategoryId" required>
                    <option *ngFor="let category of dataCategories" [value]="category.id">{{ category.categoryName }}</option>
                </select>
            </div>
            <div class="setting">
                <label for="title">Title</label>
                <input id="title" type="text" name="title" [(ngModel)]="currentMessage.title" required>
            </div>
            <div class="setting">
                <label for="start">Start</label>
                <input id="start" type="datetime-local" name="start" [ngModel]="currentMessage.startDate | date:'yyyy-MM-ddTHH:mm'" (ngModelChange)="currentMessage.startDate = updateDateString($event)" required>
            </div>
            <div class="setting">
                <label for="expire">Expire</label>
                <input id="expire" type="datetime-local" name="expire" [ngModel]="currentMessage.expirationDate | date:'yyyy-MM-ddTHH:mm'" (ngModelChange)="currentMessage.expirationDate = updateDateString($event)">
            </div>
            <div>
                <label for="message">Message</label>
                <editor id="message"
                        [init]="editorConfig"
                        licenseKey="gpl"
                        [(ngModel)]="currentMessage.message">
                </editor>
            </div>
        </div>
    </ng-container>
</div>
<div *ngIf="isAdmin" class="admin-btn-area">
    <button *ngIf="showAdmin && !addEdit" class="btn btn-small" (click)="newMessage()">New Message</button>
    <div *ngIf="showAdmin && addEdit" style="display: inline-block;">
        <button class="btn btn-small" (click)="save()">Save</button>
        <button class="btn btn-small" (click)="cancel()" style="margin-left: 5px;">Cancel</button>
    </div>
    <button class="btn btn-small right" (click)="toggleShowAdmin()">{{ showAdmin ? 'Back' : 'Admin' }}</button>
</div>
